import dataServices from '@/shared/api/dataServices';
import { set } from 'lodash';

import {
  GET_MOTOR,
  GET_SEARCH_VEHICLE,
  GET_PREMIUM,
  UPDATE_VALUE,
} from '../mutation-types';

const state = () => ({
  motor: {}
});

const mutations = {
  [GET_MOTOR](state, motorData) {
    state.motor = motorData;
  },
  [GET_SEARCH_VEHICLE](state, motorData) {
    state.motor.data.CS_DATA = { ...state.motor.data.CS_DATA, ...motorData };
  },
  [GET_PREMIUM](state, offer) {
    state.motor.data.CT_MOTOR_INSURANCE_PLAN = offer.CT_MOTOR_INSURANCE_PLAN;
  },
  [UPDATE_VALUE](state, data) {
    set(state, data.path, data.value);
  },
};
const actions = {
  async getMotorDataAction({ commit }) {
    const motorData = await dataServices.getMotorData();
    commit(GET_MOTOR, motorData);
  },
  async getMotorAdminDataAction({ commit }, data) {
    const motorData = await dataServices.getMotorAdminData(data);
    commit(GET_MOTOR, motorData);
  },
  async searchLicensePlateAction({ commit }, data) {
    const motorData = await dataServices.getSearchVehicleData(data);
    commit(GET_SEARCH_VEHICLE, motorData);
  },
  async getOfferPremium({ commit }, offer) {
    const data = await dataServices.getOfferPremiums(offer);
    commit(GET_PREMIUM, data);
  },
  updateValue({ commit }, data) {
    commit(UPDATE_VALUE, data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
